// extracted by mini-css-extract-plugin
export var brand = "_bi-9";
export var compact = "_bi-6";
export var extraSmall = "_bi-7";
export var icon = "_bi-0";
export var large = "_bi-4";
export var light = "_bi-1";
export var medium = "_bi-5";
export var outline = "_bi-b";
export var primaryDark = "_bi-a";
export var primaryLight = "_bi-8";
export var primaryModern = "_bi-c";
export var success = "_bi-2";
export var successSolid = "_bi-3";